import { pick, omit } from 'lodash';
import { layout, space, typography } from 'styled-system';

const styledProps = [...layout.propNames!, ...space.propNames!, ...typography.propNames!];

export const getStyledSystemProps = (props: Record<string, any>) => pick(props, styledProps);
export const removeStyledSystemProps = (props: Record<string, any>) => omit(props, styledProps);
